import React from 'react';
import styled from 'styled-components';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PackageAuthor from 'components/PackageInfo/PackageAuthor';
import { usePackage } from 'contexts/PackageContext';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';


const ModelNoteWrapper = styled.div`
    .note-header {
        opacity: .75;
        display: flex;
        gap: 1rem;
        align-items: center;
        justify-content: flex-start;
        margin-bottom: 1rem;
        text-transform: capitalize;

        .icon-container {
            font-size: 1.5rem;
        }

        h2 {
            margin: 0;
        }
    }
    p {
        max-width: 960px;
        white-space: pre-wrap;
    }
    .note-signature {
        opacity: .75;
        font-style: italic;
    }
`

const ModelNote = ({ modelNote, inModal }) => {
    const { currentPack } = usePackage();

    return (
        <ModelNoteWrapper $inModal={inModal}>
            <div className="note-header">
                <div className="icon-container">
                    <FontAwesomeIcon
                        flip="horizontal"
                        icon={icon({ name: 'message', family: 'classic', style: 'duotone' })}
                    />
                </div>
                <h2>Notes</h2>
            </div>
            <p>{modelNote}</p>
            <div className="note-signature">
                <PackageAuthor currentPack={currentPack} />
            </div>
        </ModelNoteWrapper>
    );
};

export default ModelNote;
